/**
 * @author: Angel Labrada Massó
 * @project: biolinea-backoffice
 * @entity: ParametersMethod
 * @version: v0.0.1
 * @date: 7/19/22
 */
import React, {memo, useMemo} from 'react';
import PropTypes from 'prop-types';
import { Tag } from 'antd';
import SelectElementCmp from '@/utils/SelectElementCmp';
import NomenclaturesTypologiesApiService from '@/modules/settings/services/NomenclaturesTypologiesApiService';

const SelectTypology = ({ value, onChange, ...props }) => {

  const getValue = useMemo(() => value?.map(item => item?._id ? item?._id : item), [value]);

  return (
    <>
      <SelectElementCmp
        queryKey={'typologies-select'}
        service={NomenclaturesTypologiesApiService}
        includeValue={''}
        value={getValue}
        onChange={onChange}
        sort={{ code: 1 }}
        queryConfig={{ refetchOnWindowFocus: false }}
        className="custom-select"
        canAdd
        mode={'multiple'}
        defaultValue={() => []}
        showDefaultValue
        {...props}
      />
    </>
  );
};

SelectTypology.propTypes = {
  value: PropTypes.string || PropTypes.object,
  onChange: PropTypes.func,
  filters: PropTypes.object
};

export default memo(SelectTypology);

const TypologyView = ({entity}) => {

  return (
    <div className="w-full my-1">
      {entity?.typologies?.length
        ? (
          <div className="flex items-center justify-start flex-wrap gap-3">
            {entity?.typologies?.map((item, idx) => <Tag key={idx}>{item?.name}</Tag>)}
          </div>
        ) : 'N/A'}
    </div>
  );
};

TypologyView.propTypes = {
  value: PropTypes.array,
  entity: PropTypes.object,
};

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Code component in a table cell
 * @param {Array} value this is the value of the dataIndex of the table
 * @param {Object} form this is the value of the dataIndex of the table
 * @param {Object} entity this is the value of the dataIndex of the table
 * */
export const renderTypology = (value, form, entity) => {
  return (
    <TypologyView value={value} entity={entity}/>
  );
};